import { render, staticRenderFns } from "./DetailsDomain.vue?vue&type=template&id=477ca29e"
import script from "./DetailsDomain.vue?vue&type=script&lang=js"
export * from "./DetailsDomain.vue?vue&type=script&lang=js"
import style0 from "./DetailsDomain.vue?vue&type=style&index=0&id=477ca29e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports